import { Injectable } from '@angular/core';
import { HistoryItemResponse } from '@shared/index';
import { AvatarImageService } from './avatar-image.service';

@Injectable({
  providedIn: 'root'
})
export class BotMessagesService {
  //Das bleibt privat
  private messages: HistoryItemResponse[] = [];

  constructor(
    private avatarimage: AvatarImageService
  ) { }

  public getMessages(): HistoryItemResponse[] {
    return this.messages;
  }

  public setMessages(messages: HistoryItemResponse[]) {
    void this.avatarimage.loadAvatarUrls();
    this.messages = messages;
  }

  public addMessage(message: HistoryItemResponse) {
    void this.avatarimage.loadAvatarUrls();
    this.messages.push(message);
  }

  public addRunMessage(message: Omit<HistoryItemResponse, "content"> & { snapshot: string; deltaStr: string; }) {
    void this.avatarimage.loadAvatarUrls();
    this.messages.push({
      item_id: message.item_id,
      _id: message._id,
      context: message.context,
      created: message.created,
      memoryEnabled: message.memoryEnabled,
      role: message.role,
      supervisorEnabled: message.supervisorEnabled,
      threadId: message.threadId,
      bypass: message.bypass,
      content: [{ text: message.deltaStr, type: 'text' }],
      reasoning: message.reasoning ?? ""
    });
  }

  public getMessageCount() {
    return this.messages.length;
  }

  public getMessage(index: number) {
    return this.messages[index];
  }

  public updateContent(index: number, content: string) {
    if (this.messages[index]?.content[0] && this.messages[index].content[0].type === 'text') {
      this.messages[index].content[0].text = content;
    }
  }

  public findMessageIndex(id: string) {
    return this.messages.findIndex(m => m._id === id);
  }

  public deleteMessage(id: string) {
    this.messages = this.messages.filter(m => m._id !== id);
  }

  public deleteMessages(ids: string[]) {
    this.messages = this.messages.filter(m => !ids.includes(m._id));
  }

  public findLatestAssistantMessage() {
    return this.messages.findLast(msg => msg.role === 'assistant');
  }
}
